import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b0a7399"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "data-testid": "OEditarGrupos" }
const _hoisted_2 = { class: "OEditarGrupos__Cabecalho" }
const _hoisted_3 = { class: "OEditarGrupos__BotoesDeAcao" }
const _hoisted_4 = { class: "ModalDeAlerta__Texto" }
const _hoisted_5 = { class: "ModalDeAlerta__Botoes" }

import UsuariosRepositorio from "@/repositorios/usuarios/usuarios.repositorio"
  import { ODadosGrupo, OSelecionarProjetosGrupo } from ".."
  import { EntidadeGenerica, EntidadeSimples } from "@/types/gerais"
  import GruposDeProjetosRepositorio from "@/repositorios/gruposDeProjetos/gruposDeProjetos.repositorio"
  import { ListarProjetos } from "@/repositorios/projeto/projeto.modelo"
  import {
    ListarUsuarios,
    ParamsUsuario,
  } from "@/repositorios/usuarios/usuarios.modelo"
  import {
    LeitorErro,
    usarLeitorDeDados,
  } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"
  import { usarEscritorDeDados } from "@/composable/UsarEscritorDeDados/usarEscritorDeDados"
  import { EditarGrupoDeProjetos } from "@/repositorios/gruposDeProjetos/gruposDeProjetos.modelo"
  import { computed, onMounted, ref } from "vue"
  import { usarMensagemUsuario } from "@/composable/UsarMensagemUsuario/usarMensagemUsuario"
  import { usarManipuladorObjetos } from "@/composable/UsarManipuladorObjetos/usarManipuladorObjetos"
  import Button from "primevue/button"
  import { MModalDeAlerta } from "@/components/Gerais"
  import useVuelidate from "@vuelidate/core"
  import { useI18n } from "vue-i18n"

  interface Props {
    idGrupo: string
    nome: string
    usuariosResponsaveis: EntidadeGenerica[]
    projetosPreSelecionados: EntidadeSimples[]
  }

  interface Emissoes {
    (event: "voltar-para-visualizacao")
    (event: "voltar-para-visualizacao-e-atualizar")
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OEditarGrupos',
  props: {
    idGrupo: null,
    nome: null,
    usuariosResponsaveis: null,
    projetosPreSelecionados: null
  },
  emits: ["voltar-para-visualizacao", "voltar-para-visualizacao-e-atualizar"],
  setup(__props: any, { emit: emitir }: { emit: ({
    (event: "voltar-para-visualizacao")
    (event: "voltar-para-visualizacao-e-atualizar")
  }), expose: any, slots: any, attrs: any }) {

const props = __props as {
    idGrupo: string
    nome: string
    usuariosResponsaveis: EntidadeGenerica[]
    projetosPreSelecionados: EntidadeSimples[]
  }

  
  

  const { t } = useI18n()

  const { leitor } = usarLeitorDeDados()
  const { colher } = usarManipuladorObjetos()
  const { onErro, onSucesso } = usarMensagemUsuario()
  const { escritor, resolver } = usarEscritorDeDados()
  const usuariosRepositorio = new UsuariosRepositorio()
  const gruposDeProjetosRepositorio = new GruposDeProjetosRepositorio()

  const lerUsuarios = leitor<ListarUsuarios, ParamsUsuario>(
    usuariosRepositorio.listarUsuarios,
    {
      "por-pagina": "1000",
    }
  )

  const editarGrupoDeProjetosEscritor = escritor<
    { id: string },
    string,
    EditarGrupoDeProjetos
  >(gruposDeProjetosRepositorio.editarGrupoDeProjetos)

  const usuariosResponsaveisOpcoes = ref<EntidadeGenerica[]>([])
  const idDoGrupoEmEdicao = ref<string>("")
  const projetosSelecionados = ref<ListarProjetos[]>([])
  const nomeDoGrupo = ref<string>("")
  const usuariosResponsaveisDoGrupo = ref<string[]>([])
  const projetosPreSelecionadosDoGrupo = ref<string[]>([])
  const mostrarModalDeAlerta = ref<boolean>(false)

  const escopoValidacao = "editarGrupo"
  const v$ = useVuelidate({ $scope: escopoValidacao })

  const estaCarregandoUsuarios = computed(() => {
    return lerUsuarios.resultado.status === "pendente"
  })

  const submissaoPendente = computed(() => {
    return editarGrupoDeProjetosEscritor.resultado.status === "pendente"
  })

  const mapearIdsDeProjetos = (projetos: ListarProjetos[]): string[] => {
    return projetos.map((projeto) => projeto.id)
  }

  const editarGrupoDeProjetos = async (): Promise<void> => {
    const idsProjetos = [
      ...mapearIdsDeProjetos(projetosSelecionados.value),
      ...projetosPreSelecionadosDoGrupo.value,
    ]

    const parametrosDeEdicao: EditarGrupoDeProjetos = {
      nome: nomeDoGrupo.value,
      idsUsuariosResponsaveis: usuariosResponsaveisDoGrupo.value,
      idsProjetos,
      ativo: true,
    }

    editarGrupoDeProjetosEscritor.mudarArgumentos([
      props.idGrupo,
      parametrosDeEdicao,
    ])
    await editarGrupoDeProjetosEscritor.executar()

    resolver<{ id: string }>(editarGrupoDeProjetosEscritor.resultado, {
      sucesso: () => {
        onSucesso({
          resumo: t('edicoesSalvasComSucesso'),
          detalhes: `${t("noGrupoDeProjetos")} "${nomeDoGrupo.value}"`,
        })
        voltarParaVisualizacaoEAtualizar()
      },
      erro: (erro: LeitorErro) => {
        onErro({
          resumo: t("erroAoEditarGrupoDeProjetos"),
          detalhes: erro.mensagem,
        })
      },
    })
  }

  const listarUsuariosResponsaveis = async (): Promise<void> => {
    await lerUsuarios.executar()

    if (lerUsuarios.resultado.status === "sucesso") {
      usuariosResponsaveisOpcoes.value = colher<
        ListarUsuarios,
        { id: string; nome: string }
      >(lerUsuarios.resultado.dados, ["id", "nome"])
    }

    if (lerUsuarios.resultado.status === "erro") {
      onErro({
        resumo: t("erroAoBuscarOsUsuariosResponsaveis"),
        detalhes: t("ocorreuUmErroAoBuscarOsUsuariosResponsaveis")
      })
    }
  }

  const carregarDados = async (): Promise<void> => {
    const atribuirUsuariosResponsaveis = (): void => {
      usuariosResponsaveisDoGrupo.value = props.usuariosResponsaveis.map(
        (usuario) => usuario.id
      )
    }

    const atribuirProjetosPreSelecionados = (): void => {
      projetosPreSelecionadosDoGrupo.value = props.projetosPreSelecionados.map(
        (projeto) => projeto.id
      )
    }

    idDoGrupoEmEdicao.value = props.nome
    nomeDoGrupo.value = props.nome
    usuariosResponsaveisOpcoes.value = props.usuariosResponsaveis

    atribuirUsuariosResponsaveis()
    atribuirProjetosPreSelecionados()
    await listarUsuariosResponsaveis()
  }

  const mostrarModalDeConfirmacao = (): void => {
    mostrarModalDeAlerta.value = true
  }

  const cancelarRetornoParaVisualizacao = (): void => {
    mostrarModalDeAlerta.value = false
  }

  const voltarParaVisualizacao = (): void => {
    mostrarModalDeAlerta.value = false
    emitir("voltar-para-visualizacao")
  }

  const voltarParaVisualizacaoEAtualizar = (): void => {
    emitir("voltar-para-visualizacao-e-atualizar")
  }

  onMounted(async () => carregarDados())

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(ODadosGrupo), {
        "nome-grupo": nomeDoGrupo.value,
        "onUpdate:nome-grupo": _cache[0] || (_cache[0] = ($event: any) => ((nomeDoGrupo).value = $event)),
        "usuarios-responsaveis": usuariosResponsaveisDoGrupo.value,
        "onUpdate:usuarios-responsaveis": _cache[1] || (_cache[1] = ($event: any) => ((usuariosResponsaveisDoGrupo).value = $event)),
        "escopo-validacao": escopoValidacao,
        "esta-carregando-usuarios-responsaveis": _unref(estaCarregandoUsuarios),
        "usuarios-responsaveis-opcoes": usuariosResponsaveisOpcoes.value
      }, null, 8, ["nome-grupo", "usuarios-responsaveis", "esta-carregando-usuarios-responsaveis", "usuarios-responsaveis-opcoes"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Button), {
          onClick: editarGrupoDeProjetos,
          class: "OEditarGrupos__BotaoConfirmar p-button-success",
          "data-testid": "OEditarGrupos__BotaoConfirmar",
          disabled: _unref(submissaoPendente) || _unref(v$).$invalid,
          label: _unref(t)('salvarAlteracoes'),
          loading: _unref(submissaoPendente),
          outlined: ""
        }, null, 8, ["disabled", "label", "loading"]),
        _createVNode(_unref(Button), {
          onClick: mostrarModalDeConfirmacao,
          class: "OEditarGrupos__BotaoCancelar p-button-danger",
          "data-testid": "OEditarGrupos__BotaoCancelar",
          disabled: _unref(submissaoPendente),
          label: _unref(t)('cancelar'),
          outlined: ""
        }, null, 8, ["disabled", "label"])
      ])
    ]),
    _createVNode(_unref(OSelecionarProjetosGrupo), {
      "projetos-pre-selecionados": projetosPreSelecionadosDoGrupo.value,
      "onUpdate:projetos-pre-selecionados": _cache[2] || (_cache[2] = ($event: any) => ((projetosPreSelecionadosDoGrupo).value = $event)),
      "projetos-selecionados": projetosSelecionados.value,
      "onUpdate:projetos-selecionados": _cache[3] || (_cache[3] = ($event: any) => ((projetosSelecionados).value = $event)),
      "altura-relativa-da-tabela": "320px",
      "buscar-ativos-e-inativos": true,
      "data-testid": "OEditarGrupos__TabelaDeAdicaoDeProjetos",
      "usuarios-responsaveis-opcoes": usuariosResponsaveisOpcoes.value
    }, null, 8, ["projetos-pre-selecionados", "projetos-selecionados", "usuarios-responsaveis-opcoes"]),
    (mostrarModalDeAlerta.value)
      ? (_openBlock(), _createBlock(_unref(MModalDeAlerta), {
          key: 0,
          cabecalho: _unref(t)('cancelarEdicaoDeGrupo'),
          class: "OEditarGrupos__ModalDeAlerta",
          "data-testid": "OEditarGrupos__ModalDeAlerta",
          fechavel: false,
          "model-value": mostrarModalDeAlerta.value
        }, {
          conteudo: _withCtx(() => [
            _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(t)('aoCancelarVocePerderaTodasAsAlteracoesFeitasNoGrupoDeProjetos')), 1)
          ]),
          acoes: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_unref(Button), {
                onClick: cancelarRetornoParaVisualizacao,
                class: "ModalDeAlerta__BotaoCancelar p-button-text",
                label: _unref(t)('voltarEditar'),
                outlined: ""
              }, null, 8, ["label"]),
              _createVNode(_unref(Button), {
                onClick: voltarParaVisualizacao,
                class: "ModalDeAlerta__BotaoConfirmar p-button-danger",
                "data-testid": "OEditarGrupos__BotaoConfirmarModal",
                label: _unref(t)('simCancelar'),
                outlined: ""
              }, null, 8, ["label"])
            ])
          ]),
          _: 1
        }, 8, ["cabecalho", "model-value"]))
      : _createCommentVNode("", true)
  ]))
}
}

})